<template>
  <div class="header">
    <div class="logo"><a href="/"><img src="../../assets/images/logo.png" alt=""></a></div>
    <el-menu
      :default-active="$route.path"
      class="el-menu-demo"
      id="w"
      mode="horizontal"
      @select="handleSelect"
      text-color="#fff"
      active-text-color="#ffe400"
      router>
      <el-menu-item id="home" index="/">首页</el-menu-item>
      <el-submenu index="/trend" :class="{'curr':this.$route.path === '/trend' || this.$route.query.cate === 'trend'}">
        <template slot="title">
          <router-link to="trend" id="trend" class="menu-name">大势</router-link>
        </template>
        <div class="gd">
<!--          <el-menu-item index="/trend?activeName=first&currentTab=first" :disabled="!token" class="dropdown-menu bold">首席观点</el-menu-item>-->
          <el-menu-item index="/trend?activeName=second&currentTab=second" :disabled="!token" class="dropdown-menu Ti">中国首席财经</el-menu-item>
          <el-menu-item index="/trend?activeName=third&currentTab=third" :disabled="!token" class="dropdown-menu Ti">首席证券内参</el-menu-item>
<!--          <el-menu-item index="/trend?activeName=fourth&currentTab=fourth" :disabled="!token" class="dropdown-menu Ti">首席策略研判</el-menu-item>-->
        </div>
<!--            2023030隐藏-->
<!--        <div class="ck">-->
<!--          <el-menu-item index="/trend?activeCkName=five&currentCkTab=five" :disabled="!token" class="dropdown-menu bold">决策参考</el-menu-item>-->
<!--          <el-menu-item index="/trend?activeCkName=six&currentCkTab=six" :disabled="!token" class="dropdown-menu Ti">高层决策内参</el-menu-item>-->
<!--          <el-menu-item index="/trend?activeCkName=seven&currentCkTab=seven" :disabled="!token" class="dropdown-menu Ti">金融机构内参</el-menu-item>-->
<!--          <el-menu-item index="/trend?activeCkName=eight&currentCkTab=eight" :disabled="!token" class="dropdown-menu Ti">国际资讯参考</el-menu-item>-->
<!--        </div>-->

      </el-submenu>
      <el-submenu index="3" :class="{'curr':this.$route.path === '/review' || this.$route.query.cate === 'review'}">
        <template slot="title">
          <router-link to="review" id="review" class="menu-name">复盘</router-link>
        </template>
        <el-menu-item index="/review?activeName=first&currentTab=first" :disabled="!token" class="dropdown-menu bold">收盘观潮</el-menu-item>
        <el-menu-item index="/review?activeName=second&currentTab=second" :disabled="!token" class="dropdown-menu bold">数据解盘</el-menu-item>
        <el-menu-item index="/review?activeName=third&currentTab=third" :disabled="!token" class="dropdown-menu bold">每周复盘</el-menu-item>
      </el-submenu>
      <el-submenu index="4"  :class="{'curr':this.$route.path === '/market' || this.$route.query.cate === 'market'}">
        <template slot="title">
          <router-link to="market" id="market" class="menu-name">市场</router-link>
        </template>
<!--        <el-menu-item index="/market?activeName=first&currentTab=first" :disabled="!token" class="dropdown-menu bold">7*24 VIP解读</el-menu-item>-->
        <el-menu-item index="/market?activeName=second&currentTab=second" :disabled="!token" class="dropdown-menu Ti">精选头条</el-menu-item>
        <el-menu-item index="/market?activeName=third&currentTab=third" :disabled="!token" class="dropdown-menu Ti">市场热点</el-menu-item>
        <el-menu-item index="/market?activeName=fourth&currentTab=fourth" :disabled="!token" class="dropdown-menu Ti">盘中直击</el-menu-item>
        <el-menu-item index="/market?activeName=five&currentTab=five" :disabled="!token" class="dropdown-menu Ti">要闻点评</el-menu-item>
<!--        <el-menu-item index="/market?activeName=six&currentTab=six" :disabled="!token" class="dropdown-menu bold">每日A股大参考</el-menu-item>-->
<!--        <el-menu-item index="/market?activeName=seven&currentTab=seven" :disabled="!token" class="dropdown-menu bold">融资融券参考</el-menu-item>-->
      </el-submenu>
      <el-submenu index="5"  :class="{'curr':this.$route.path === '/chance' || this.$route.query.cate === 'chance'}">
        <template slot="title">
          <router-link to="chance" id="chance" class="menu-name">机会</router-link>
        </template>
        <el-menu-item index="/chance?activeName=first&currentTab=first" :disabled="!token" class="dropdown-menu bold">盘前必读</el-menu-item>
        <el-menu-item index="/chance?activeName=second&currentTab=second" :disabled="!token" class="dropdown-menu Ti">早安谍报</el-menu-item>
        <el-menu-item index="/chance?activeName=third&currentTab=third" :disabled="!token" class="dropdown-menu Ti">盘前点金</el-menu-item>
        <el-menu-item index="/chance?activeName=fourth&currentTab=fourth" :disabled="!token" class="dropdown-menu Ti">题材挖掘</el-menu-item>
        <el-menu-item index="/chance?activeName=five&currentTab=five" :disabled="!token" class="dropdown-menu bold">投资日历</el-menu-item>
        <el-menu-item index="/chance?activeName=six&currentTab=six" :disabled="!token" class="dropdown-menu bold">脱水研报</el-menu-item>
      </el-submenu>
<!--      <el-menu-item id="risk" index="/risk" :class="{'currN':this.$route.path === '/risk' || this.$route.query.cate === 'risk'}">风险</el-menu-item>-->
      <el-submenu index="7"  :class="{'curr':this.$route.path === '/stocks' || this.$route.query.cate === 'stocks'}">
        <template slot="title">
          <router-link to="stocks" id="stocks" class="menu-name">个股</router-link>
        </template>
        <el-menu-item index="/stocks?activeName=second&currentTab=second" :disabled="!token" class="dropdown-menu bold">新股</el-menu-item>
<!--        <el-menu-item index="/stocks" class="dropdown-menu">打新专刊</el-menu-item>-->
<!--        <el-menu-item index="/stocks" class="dropdown-menu">研选新股</el-menu-item>-->
        <el-menu-item index="/stocks?activeRgName=fourth&currentRgTab=fourth" :disabled="!token" class="dropdown-menu bold">热股</el-menu-item>
<!--        <el-menu-item index="/stocks" class="dropdown-menu">涨停分析</el-menu-item>-->
<!--        <el-menu-item index="/stocks" class="dropdown-menu">涨停预测</el-menu-item>-->
<!--        <el-menu-item index="/stocks" class="dropdown-menu">强势股解析</el-menu-item>-->
  <!--      <el-menu-item index="/stocks?activeKcName=eight&currentKcTab=eight" :disabled="!token" class="dropdown-menu bold">科创</el-menu-item>-->
<!--        <el-menu-item index="/stocks" class="dropdown-menu">图研</el-menu-item>-->
<!--        <el-menu-item index="/stocks" class="dropdown-menu">研选</el-menu-item>-->
        <el-menu-item index="/stocks?activeName=one&currentTab=one" :disabled="!token" class="dropdown-menu bold">智选</el-menu-item>
<!--        <el-menu-item index="/stocks" class="dropdown-menu">AI研选</el-menu-item>-->
<!--        <el-menu-item index="/stocks" class="dropdown-menu">AI诊股</el-menu-item>-->
      </el-submenu>
      <!-- 投顾菜单已隐藏 -->
      <el-submenu index="9" :class="{'curr':this.$route.path === '/feature' || this.$route.query.cate === 'feature'}">
        <template slot="title">
          <router-link to="feature" id="feature" class="menu-name">特色</router-link>
        </template>
        <el-menu-item index="/feature?activeName=first&currentTab=first" :disabled="!token" class="dropdown-menu bold">每日A股大参考</el-menu-item>
<!--        <el-menu-item index="/feature?activeName=third&currentTab=third" class="dropdown-menu Ti">配置</el-menu-item>-->
<!--        <el-menu-item index="/feature?activeName=fourth&currentTab=fourth" class="dropdown-menu Ti">行情</el-menu-item>-->
<!--        <el-menu-item index="/feature?activeName=five&currentTab=five" class="dropdown-menu Ti">选基</el-menu-item>-->
        <el-menu-item index="/feature?activeName=second&currentTab=second" :disabled="!token" class="dropdown-menu bold">融资融券参考</el-menu-item>
        <el-menu-item index="/feature?activeName=six&currentTab=six" :disabled="!token" class="dropdown-menu bold">港股通投资参考</el-menu-item>
        <el-menu-item index="/feature?activeName=seven&currentTab=seven" :disabled="!token" class="dropdown-menu bold">理财周刊</el-menu-item>
<!--        <el-menu-item index="/feature?activeName=eight&currentTab=eight" :disabled="!token" class="dropdown-menu bold">基金</el-menu-item>-->
        <el-menu-item index="/feature?activeName=six&currentTab=nine" :disabled="!token" class="dropdown-menu bold">可转债投资指南</el-menu-item>
        <el-menu-item index="/feature?activeName=seven&currentTab=ten" :disabled="!token" class="dropdown-menu bold">ETF投资参考</el-menu-item>
      </el-submenu>
<!--      <el-menu-item id="lib" index="/InvestmentResearchLibrary" :class="{'currN':this.$route.query.cate === 'library'}">投研库</el-menu-item>-->
<!--      20230308隐藏-->
      <el-submenu index="10" :class="{'curr':this.$route.path === '/InvestmentResearchLibrary' || this.$route.query.cate === 'library'}">
        <template slot="title">
          <router-link to="InvestmentResearchLibrary" id="lib" class="menu-name">投研库</router-link>
        </template>
        <el-menu-item index="/InvestmentResearchLibrary?activeName=first" :disabled="!token" class="dropdown-menu bold">大行研报库</el-menu-item>
        <!--<el-menu-item index="/InvestmentResearchLibrary?activeName=second" :disabled="!token" class="dropdown-menu bold">金融谍报在线</el-menu-item>
        <el-menu-item index="/InvestmentResearchLibrary?activeName=third" :disabled="!token" class="dropdown-menu bold">证券微讯库</el-menu-item>
        <el-menu-item :disabled="!token" class="dropdown-menu"><a class="bold" style="color: black" href="https://dfzq.bolanjr.com/bolaninfo/" target="_blank">数据中心</a></el-menu-item>-->
      </el-submenu>

      <!-- 投教菜单已隐藏 -->
    </el-menu>


    <div class="search">
      <el-row>
        <el-col :span="6">
          <el-input
            type="text"
            prefix-icon="el-icon-search"
            v-model="value"
            placeholder="请输入关键字"
            style="min-width: 200px;cursor: pointer;border-radius: 30px"
            @change="Search"
          ></el-input>
        </el-col>
      </el-row>
    </div>


      <div class="user">
            <div class="user_content">
              <a v-if="!isMember" href="#/Member" class="vip-link">开通会员</a>
              <a v-else href="#/UCenter" class="vip-badge" :title="'会员到期：' + memberExpire">
                <span class="vip-text">尊享VIP</span>
              </a>
              <el-dropdown  @command="handleLogin('HI')" v-if="!token">
                <span class="el-avatar el-avatar--icon el-avatar--circle">
              <i v-if="!token" class="el-icon-user-solid"></i>
                <a href="#/UCenter">
                  <img v-if="token" class="avatar" src="../../assets/images/20221018.png" alt="">
                </a>
              </span>
                <span class="el-dropdown-link"><i class="userIcon el-icon-arrow-down el-icon--right"></i></span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item>登录</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>

              <el-dropdown v-if="token">
                <span class="el-avatar el-avatar--icon el-avatar--circle">
              <i v-if="!token" class="el-icon-user-solid"></i>
                <a href="#/UCenter">
                  <img v-if="token" class="avatar" src="../../assets/images/20221018.png" alt="">
                </a>
              </span>
                <span class="el-dropdown-link"><i class="userIcon el-icon-arrow-down el-icon--right"></i></span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item @click.native="ExitLogin">退出登录</el-dropdown-item>
                  <el-dropdown-item><a href="#/UCenter">个人中心</a></el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
      </div>
    <div style="display: none" v-trigger @click="handleLogin"></div>
    <login v-if="VisiAble" ref="dialog"></login>
  </div>
</template>

<script>
import Login from "./Login";
import { myProduct } from "@/api/user";
import { orderList } from "@/api/order";
export default {
  name: "Header",
  components:{
    Login
  },
  directives: {
    trigger: {
      inserted(el, binging) {
        const firstDate = localStorage.getItem('firstDate');
        // 获取当前时间（年月日）
        const now = new Date().toLocaleDateString();
        // 转换成时间戳
        const time = Date.parse(new Date(now));
        const token = window.localStorage.getItem('token');
        if (!firstDate && !token) {
          // console.log('time1', '今天第一次开启1')
          localStorage.setItem('firstDate', JSON.stringify(time))
            el.click()
        } else {
          if (time > firstDate) {
            // console.log('time2', '今天第一次开启2')
            localStorage.setItem('firstDate', JSON.stringify(time))
          }
        }
      }
    }
  },
  data() {
    return {
      activeIndex: '1',
      value: '',
      token: window.localStorage.getItem('token'),
      VisiAble: false,
      isMember: false,
      memberExpire: '',
    };
  },
  created() {
    this.checkMemberStatus();
  },
  methods: {
    checkMemberStatus() {
      const username = window.localStorage.getItem('username');
      this.token = window.localStorage.getItem('token');
      if (!username) {
        this.isMember = false;
        return;
      }
      // 只有status=2(已开通)且未过期的订单才算会员
      orderList({username: username}).then((res) => {
        if (res && (res.code === 2000 || res.code === 200) && res.data && res.data.length > 0) {
          const now = new Date();
          const memberOrder = res.data.find(item => {
            if (item.status !== 2) return false;
            if (!item.expire_time) return true;
            return new Date(item.expire_time) > now;
          });
          this.isMember = !!memberOrder;
          if (memberOrder && memberOrder.expire_time) {
            this.memberExpire = memberOrder.expire_time.split(' ')[0];
          } else {
            this.memberExpire = '';
          }
        } else {
          this.isMember = false;
          this.memberExpire = '';
        }
      }).catch(() => {
        this.isMember = false;
        this.memberExpire = '';
      });
    },
    handleSelect(key, keyPath) {
      // console.log(key, keyPath);
    },
    handleLogin(data) {
      this.VisiAble=true;
      this.$nextTick(()=>{
        this.$refs.dialog.init(data);
      })
    },
    ExitLogin () {
      window.localStorage.clear();
      this.$router.push('/')
      this.$router.go(0)
    },
    F5(){
      window.location.reload();
    },
    Search (){
      this.$router.push({path: '/search',query:{ keyword:this.value}});
    }
  },
  watch:{
    $route:function(newVal,oldVal){
      // 路由变化时重新检查会员状态（支付成功后返回首页等场景）
      this.checkMemberStatus();
    }
  }
}
</script>

<style scoped>
.curr div a:after {
  display: block;
  content: "";
  border-bottom: 4px solid #ffe400;
  margin-top: -4px;
}
.curr div a{
  color: #ffe400;
}
.currN{
  color: #ffe400!important;
}
.currN:after{
  display: block;
  content: "";
  border-bottom: 4px solid #ffe400;
  margin-top: -4px;
}
.header {
  width: 100%;
  position: fixed;
  top: 0;
  z-index: 99999;
  display: flex;
  height: 50px;
  line-height: 50px;
  background-color: #040f27;
}
.avatar{
  width: 30px;
  height: 30px;
}
.el-menu-item{
  font-size: 16px;
}
.el-submenu__title{
  font-size: 16px;
}
.el-menu--popup {
  display: flex!important;
  min-width: 300px!important;
  letter-spacing: 2px!important;
  justify-content: space-between!important;
  text-align: center!important;
}

.el-menu--horizontal>.el-submenu .el-submenu__title:hover {
  background-color: #040f27;
}

.el-menu--horizontal>.el-menu-item:hover{
  background-color: #040f27;
}

.bold{
  font-weight: 600;
}

.Ti{
  text-indent: 2em;
}

.dropdown-menu{
  color: black!important;
  padding: 0 10px 0 20px!important;
}

.logo {
  flex: .25;
}

.logo img {
  width: 200px;
  height: 30px;
  object-fit: contain;
  vertical-align: middle;
  padding-left: 30px;
}

.search {
  /*visibility:hidden;*/
}

.el-menu--horizontal>.el-menu-item.is-active:after{
  display: block;
  content: "";
  border-bottom: 4px solid #ffe400;
  margin-top: -4px;
}

.el-menu--horizontal > .el-menu-item {
  border-bottom: none;
  text-decoration: none;
}

 .el-input--prefix .el-input__inner {
  border-radius: 30px;
  height: 30px;
  color: white;
  background-color: #223253;
  border: 1px solid #223253;
}

.el-menu-demo {
  display: flex;
  width: 1200px;
  margin: 0 auto;
  position: relative;
  left: 20px;
  background-color: #040f27;
}

.el-menu-demo li {
  background-color: #040f27!important;
}

 .el-menu.el-menu--horizontal {
  border: none;
}

.el-menu--horizontal>.el-submenu .el-submenu__title{
  display: flex;
}

.el-menu--horizontal>.el-submenu .el-submenu__icon-arrow{
  line-height: 60px;
}

.menu-name {
  color: #FFFFFF;
}

.user {
  width: 100px;
  flex: .1;
  margin-right: 5%;
}

.el-dropdown {
  display: flex;
  position: relative;
  color: #606266;
  font-size: 14px;
}

.user_content {
  display: flex;
  align-items: center;
}

.el-avatar--icon {
  font-size: 18px;
}

.el-avatar--circle {
  border-radius: 50%;
}

.el-avatar {
  display: inline-block;
  text-align: center;
  margin-top: 10px;
  overflow: hidden;
  color: #fff;
  width: 30px;
  height: 30px;
  line-height: 30px;
}

.userIcon {
  color: #fff;
  font-size: 20px;
}

.vip-link {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #f0c36d, #e6a23c);
  color: #001646;
  font-size: 14px;
  font-weight: 600;
  height: 30px;
  line-height: 30px;
  padding: 0 16px;
  border-radius: 20px;
  margin-left: 10px;
  margin-right: 15px;
  text-decoration: none;
  white-space: nowrap;
  box-sizing: border-box;
}

.vip-link:hover {
  background: linear-gradient(135deg, #f5d088, #ebb953);
}

.vip-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%);
  color: #f0c36d;
  font-size: 14px;
  font-weight: 900;
  height: 30px;
  line-height: 30px;
  padding: 0 16px;
  border-radius: 15px;
  margin-left: 10px;
  margin-right: 15px;
  text-decoration: none;
  letter-spacing: 2px;
  border: 1.5px solid #f0c36d;
  box-shadow: 0 0 8px rgba(240, 195, 109, 0.4);
  position: relative;
  overflow: hidden;
  animation: vipGlow 2s ease-in-out infinite alternate;
  min-width: 70px;
}

@keyframes vipGlow {
  0% {
    box-shadow: 0 0 6px rgba(240, 195, 109, 0.3), 0 0 12px rgba(240, 195, 109, 0.1);
  }
  100% {
    box-shadow: 0 0 12px rgba(240, 195, 109, 0.6), 0 0 20px rgba(240, 195, 109, 0.3);
  }
}

.vip-badge .vip-text {
  position: relative;
  z-index: 2;
  text-shadow: 0 0 8px rgba(240, 195, 109, 0.5);
}

.vip-badge::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(240, 195, 109, 0.3), transparent);
  animation: vipShine 2.5s ease-in-out infinite;
  z-index: 1;
}

@keyframes vipShine {
  0% { left: -100%; }
  50%, 100% { left: 100%; }
}

.vip-badge:hover {
  color: #ffe4a0;
  border-color: #ffe4a0;
  box-shadow: 0 0 16px rgba(240, 195, 109, 0.7), 0 0 28px rgba(240, 195, 109, 0.4);
  animation: none;
}
</style>



// WEBPACK FOOTER //
// src/components/common/Header.vue